import { staticText } from '../../../utils/translations/staticText';

export const moneyMaxTranslation = staticText({});
